module.exports = __webpack_public_path__ + "static/character-2-52aef74ebba135ffb33daf66bdfb4f97.png";